import '@progress/kendo-theme-default/dist/all.css';
import { createRoot } from 'react-dom/client';
import App from './app';
import './index.css';

//import './Site.css';
//import './new-site.css';
import 'eone-ui/css/site.css';

console.group('Info');
console.log('__COMMIT_HASH__', __COMMIT_HASH__);
console.groupEnd();

if (import.meta.env.MODE === 'development') {
  console.log('import.meta.env', import.meta.env);
}

const rootElement = document.getElementById('root');
const root = createRoot(rootElement as HTMLElement);
root.render(<App />);
